import React from 'react'
import './styles.scss'
import { Spin } from 'antd'

import FileItem   from './file-item'
import EmptyState from '../../Shared/EmptyState'

export default ({ files, files_loading, on_cancel, on_retry, is_transfer_agent_running, transfer_server_error}) => (
  <div className={'files'}>
    {
      (files_loading && (!files || files.length === 0)) ?
        <Spin size='small' tip='Loading...' style={{ padding: '15% 50%', margin: '0 auto' }} /> :

        ((!files || files.length === 0) ?
          <EmptyState title={ transfer_server_error ? 'error' : 'No Ongoing Transfers'}
                      description={transfer_server_error ? transfer_server_error : ( is_transfer_agent_running ? '' : 'Transfer requires CloudFlyer Transfer agent. Please launch the agent first.”')}
                      error={transfer_server_error}
                      click_text={transfer_server_error ? 'Retry' : 'Refresh'}
                        on_click={on_retry}/> :
          (files.map((file, index) =>
              <FileItem key        = {index}
                        file       = {file}
                        on_cancel  = {on_cancel}
              />)
        ))
    }
  </div>
)
